import apple from '../images/plants/apple.png';
import apricot from '../images/plants/apricot.jpg';
import artichoke from '../images/plants/artichoke.jpg';
import alfalfa from '../images/plants/alfalfa.jpg';
import avocado from '../images/plants/avocado.jpg';
import amaranth from '../images/plants/amaranth.jpg';
import arugula from '../images/plants/arugula.jpg';
import asparagus from '../images/plants/asparagus.jpg';
import aubergine from '../images/plants/aubergine.png';
import bambooShoot from '../images/plants/bamboo shoot.jpg';
import beans from '../images/plants/beans.jpg';
import beet from '../images/plants/beet.jpg';
import bellPepper from '../images/plants/bell pepper.png';
import blackBean from '../images/plants/black bean.jpg';
import blackCherry from '../images/plants/black cherry.png';
import blackberry from '../images/plants/blackberry.jpg';
import blackeyedPeas from '../images/plants/black-eyed peas.jpg';
import blueberry from '../images/plants/blueberry.jpg';
import bokChoy from '../images/plants/bok choy.jpg';
import broccoli from '../images/plants/broccoli.jpg';
import brusselsSprout from '../images/plants/brussels sprout.gif';
import buckwheat from '../images/plants/buckwheat.jpg';
import burdock from '../images/plants/burdock.jpg';
import buttercupSquash from '../images/plants/buttercup squash.jpg';
import butternutSquash from '../images/plants/butternut squash.jpg';
import cabbage from '../images/plants/cabbage.png';
import cantaloupe from '../images/plants/cantaloupe.jpg';
import caper from '../images/plants/caper.png';
import caraway from '../images/plants/caraway.jpg';
import carrot from '../images/plants/carrot.jpg';
import cauliflower from '../images/plants/cauliflower.gif';
import cayennePepper from '../images/plants/cayenne pepper.jpg';
import celery from '../images/plants/celery.png';
import chamomile from '../images/plants/chamomile.jpg';
import chickpea from '../images/plants/chickpea.jpg';
import chicory from '../images/plants/chicory.jpg';
import chiliPepper from '../images/plants/chili pepper.png';
import chineseCabbage from '../images/plants/chinese cabbage.jpg';
import chives from '../images/plants/chives.jpg';
import cilantro from '../images/plants/cilantro.jpg';
import coriander from '../images/plants/coriander.jpg';
import collardGreens from '../images/plants/collard greens.jpg';
import corn from '../images/plants/corn.jpg';
import cranberry from '../images/plants/cranberry.jpg';
import cucumber from '../images/plants/cucumber.jpg';
import cumin from '../images/plants/cumin.jpg';
import daikonRadish from '../images/plants/daikon radish.jpg';
import dill from '../images/plants/dill.png';
import eggplant from '../images/plants/eggplant.png';
import fennel from '../images/plants/fennel.jpg';
import fiddlehead from '../images/plants/fiddlehead.jpg';
import garlic from '../images/plants/garlic.jpg';
import ginger from '../images/plants/ginger.jpg';
import grannySmith from '../images/plants/granny smith.jpg';
import grape from '../images/plants/grape.jpg';
import greenBean from '../images/plants/green bean.jpg';
import habaneroPepper from '../images/plants/habanero pepper.jpg';
import honeydewMelon from '../images/plants/honeydew melon.jpg';
import horseradish from '../images/plants/horseradish.jpg';
import italianPepper from '../images/plants/italian pepper.png';
import jalapenoPepper from '../images/plants/jalapeno pepper.jpg';
import jicama from '../images/plants/jicama.jpg';
import kale from '../images/plants/kale.jpg';
import leek from '../images/plants/leek.jpg';
import lentil from '../images/plants/lentil.jpg';
import lettuce from '../images/plants/lettuce.jpg';
import lemon from '../images/plants/lemon.png';
import limaBean from '../images/plants/lima bean.png';
import mustardGreen from '../images/plants/mustard green.jpg';
import lime from '../images/plants/lime.jpg';
import navyBean from '../images/plants/navy bean.png';
import okra from '../images/plants/okra.png';
import olive from '../images/plants/olive.png';
import onion from '../images/plants/onion.jpg';
import orange from '../images/plants/orange.jpg';
import parsnip from '../images/plants/parsnip.jpg';
import peach from '../images/plants/peach.jpg';
import peas from '../images/plants/peas.png';
import peanut from '../images/plants/peanut.jpg';
import persimmon from '../images/plants/persimmon.jpg';
import pimiento from '../images/plants/pimiento.png';
import pintoBean from '../images/plants/pinto bean.jpg';
import plum from '../images/plants/plum.png';
import pomagranate from '../images/plants/pomagranate.jpg';
import potato from '../images/plants/potato.jpg';
import pumpkin from '../images/plants/pumpkin.png';
import quinoa from '../images/plants/quinoa.jpg';
import radish from '../images/plants/radish.png';
import raspberry from '../images/plants/raspberry.jpg';
import rhubarb from '../images/plants/rhubarb.jpg';
import romaineLettuce from '../images/plants/romaine lettuce.jpg';
import rutabaga from '../images/plants/rutabaga.jpg';
import shallot from '../images/plants/shallot.jpg';
import soyBean from '../images/plants/soy bean.jpg';
import spaghettiSquash from '../images/plants/spaghetti squash.jpg';
import spinach from '../images/plants/spinach.jpg';
import squash from '../images/plants/squash.jpg';
import sugarBeet from '../images/plants/sugar beet.jpg';
import sunflower from '../images/plants/sunflower.jpg';
import sweetPotato from '../images/plants/sweet potato.jpg';
import strawberry from '../images/plants/strawberry.jpg';
import chard from '../images/plants/chard.jpg';
import tomatillo from '../images/plants/tomatillo.jpg';
import tomato from '../images/plants/tomato.jpg';
import turnip from '../images/plants/turnip.png';
import watercress from '../images/plants/watercress.jpg';
import watermelon from '../images/plants/watermelon.jpg';
import wheatgrass from '../images/plants/wheatgrass.png';
import yam from '../images/plants/yam.png';
import zucchini from '../images/plants/zucchini.jpg';

const plantList = [
  { name: 'apple', img: apple },
  { name: 'apricot', img: apricot },
  { name: 'artichoke', img: artichoke },
  { name: 'alfalfa', img: alfalfa },
  { name: 'avocado', img: avocado },
  { name: 'amaranth', img: amaranth },
  { name: 'arugula', img: arugula },
  { name: 'asparagus', img: asparagus },
  { name: 'aubergine', img: aubergine },
  { name: 'bamboo shoot', img: bambooShoot },
  { name: 'beans', img: beans },
  { name: 'beet', img: beet },
  { name: 'bell pepper', img: bellPepper },
  { name: 'black bean', img: blackBean },
  { name: 'black cherry', img: blackCherry },
  { name: 'blackberry', img: blackberry },
  { name: 'black-eyed peas', img: blackeyedPeas },
  { name: 'blueberry', img: blueberry },
  { name: 'bok choy', img: bokChoy },
  { name: 'broccoli', img: broccoli },
  { name: 'brussels sprout', img: brusselsSprout },
  { name: 'buckwheat', img: buckwheat },
  { name: 'burdock', img: burdock },
  { name: 'buttercup squash', img: buttercupSquash },
  { name: 'butternut squash', img: butternutSquash },
  { name: 'cabbage', img: cabbage },
  { name: 'cantaloupe', img: cantaloupe },
  { name: 'caper', img: caper },
  { name: 'caraway', img: caraway },
  { name: 'carrot', img: carrot },
  { name: 'cauliflower', img: cauliflower },
  { name: 'cayenne pepper', img: cayennePepper },
  { name: 'celery', img: celery },
  { name: 'chamomile', img: chamomile },
  { name: 'chickpea', img: chickpea },
  { name: 'chicory', img: chicory },
  { name: 'chili pepper', img: chiliPepper },
  { name: 'chinese cabbage', img: chineseCabbage },
  { name: 'chives', img: chives },
  { name: 'cilantro', img: cilantro },
  { name: 'collard greens', img: collardGreens },
  { name: 'coriander', img: coriander },
  { name: 'corn', img: corn },
  { name: 'cranberry', img: cranberry },
  { name: 'cucumber', img: cucumber },
  { name: 'cumin', img: cumin },
  { name: 'daikon radish', img: daikonRadish },
  { name: 'dill', img: dill },
  { name: 'eggplant', img: eggplant },
  { name: 'fennel', img: fennel },
  { name: 'fiddlehead', img: fiddlehead },
  { name: 'garlic', img: garlic },
  { name: 'ginger', img: ginger },
  { name: 'granny smith', img: grannySmith },
  { name: 'grape', img: grape },
  { name: 'green bean', img: greenBean },
  { name: 'habanero pepper', img: habaneroPepper },
  { name: 'honeydew melon', img: honeydewMelon },
  { name: 'horseradish', img: horseradish },
  { name: 'italian pepper', img: italianPepper },
  { name: 'jalapeno pepper', img: jalapenoPepper },
  { name: 'jicama', img: jicama },
  { name: 'kale', img: kale },
  { name: 'leek', img: leek },
  { name: 'lentil', img: lentil },
  { name: 'lettuce', img: lettuce },
  { name: 'lemon', img: lemon },
  { name: 'lima bean', img: limaBean },
  { name: 'lime', img: lime },
  { name: 'mustard green', img: mustardGreen },
  { name: 'navy bean', img: navyBean },
  { name: 'okra', img: okra },
  { name: 'olive', img: olive },
  { name: 'onion', img: onion },
  { name: 'orange', img: orange },
  { name: 'parsnip', img: parsnip },
  { name: 'peach', img: peach },
  { name: 'peas', img: peas },
  { name: 'peanut', img: peanut },
  { name: 'persimmon', img: persimmon },
  { name: 'pimiento', img: pimiento },
  { name: 'pinto bean', img: pintoBean },
  { name: 'plum', img: plum },
  { name: 'pomagranate', img: pomagranate },
  { name: 'potato', img: potato },
  { name: 'pumpkin', img: pumpkin },
  { name: 'quinoa', img: quinoa },
  { name: 'radish', img: radish },
  { name: 'raspberry', img: raspberry },
  { name: 'rhubarb', img: rhubarb },
  { name: 'romaine lettuce', img: romaineLettuce },
  { name: 'rutabaga', img: rutabaga },
  { name: 'shallot', img: shallot },
  { name: 'soy bean', img: soyBean },
  { name: 'spaghetti squash', img: spaghettiSquash },
  { name: 'spinach', img: spinach },
  { name: 'squash', img: squash },
  { name: 'sugar beet', img: sugarBeet },
  { name: 'sunflower', img: sunflower },
  { name: 'sweet potato', img: sweetPotato },
  { name: 'strawberry', img: strawberry },
  { name: 'chard', img: chard },
  { name: 'tomatillo', img: tomatillo },
  { name: 'tomato', img: tomato },
  { name: 'turnip', img: turnip },
  { name: 'watercress', img: watercress },
  { name: 'watermelon', img: watermelon },
  { name: 'wheatgrass', img: wheatgrass },
  { name: 'yam', img: yam },
  { name: 'zucchini', img: zucchini },
];

export default plantList;
